import { useState } from "react";

import moment from "moment-timezone";
import SVGComponent from "../../../../../Components/SVGComponent";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import { fn } from "../../../../../Functions";

import "./EpisodeList.scss";

const EpisodeList = ({
    serviceId, titleId,
    title, episodes
}:{
    serviceId: string, titleId: string,
    title: TitleType & TitleAugmentedData, episodes: EpisodeType[]
}) => {
    const [ sortCriteria, setSortCriteria ] = useState<"first"|"latest">("first");
    const [ isPayAsking, setIsPayAsking ] = useState<boolean>(false);

    const sortEpisodes = (a: EpisodeType, b: EpisodeType): number => {
        const compareValue = Number(a.episodeId) - Number(b.episodeId);
        return sortCriteria === "first" ? compareValue : -compareValue;
    };

    const sortedEpisodes = [...episodes].sort(sortEpisodes);

    return (<div className={"EpisodeListSection"}>
        <div className={"EpisodeListHeader"}>
            <div className={"EpisodeCount"}>
                {`총 ${sortedEpisodes.length}화`}
            </div>
            <div className={"SortingButton"}>
                <div 
                    className={`FromFirstTitle ${sortCriteria==='first'?"Selected":""}`}
                    onClick={() => setSortCriteria("first")}
                >{"1화부터"}</div>
                <div className={"Divider"}>{"l"}</div>
                <div 
                    className={`FromLastestTitle ${sortCriteria==='latest'?"Selected":""}`} 
                    onClick={() => setSortCriteria("latest")}
                >{"최신순"}</div>
            </div>
        </div>
        <div className={"EpisodeItems"}>
            {sortedEpisodes.map( episode => (
                <EpisodeItem 
                    key={episode.episodeId}
                    serviceId={serviceId} titleId={titleId} 
                    thumbnail={episode?.thumbnail || title?.thumbnail}
                    title={title} episode={episode}
                    setIsPayAsking={setIsPayAsking}
                />  
            ))}
        </div>
        {title.timeRemain === 0 &&
        <div className={"EventZone"}
        >
            <Button className={"EventBanner"}
                href={`/payment/${serviceId}/${titleId}`}
                onClick={(e) => {
                    localStorage.setItem("promotionCode", "_10p");
                    fn.gotoByAnchor(e);
                }}
            >
                <img src={"https://static.novela.today/Image/Banner-Blur-Celebration.png"} alt={'BannerBg'} className={"BannerBG"} />
                <div className={"TextBox"}>
                    <div className={"SubTitle"}>{"숨겨진 배너를"}</div>
                    <div className={"Title"}>{"발견한 당신에게만 드리는 특별 혜택"}</div>
                    <div className={"BenefitBox"}>
                        <div onClick={() => fn.goto(`/payment/${serviceId}/${titleId}`)} >
                            {"최대 할인 혜택 확인"}
                        </div>
                        <SVGComponent 
                            src={"https://static.novela.today/icon/chevron_right_thick.svg"}
                            width={24} height={24} 
                            color={"rgb(255, 120, 102)"}
                        />
                    </div>
                </div>
                <div className={"ImageBox"}>    
                    <img
                        src={"https://static.novela.today/Image/Banner-Pray-Illustration.png"}
                        alt={'Illustration'}
                        width={112} height={109}
                    />
                </div>
            </Button>
        </div>}
        <Dialog className={"PayAskingDialog"} open={isPayAsking} onClose={() => setIsPayAsking(false)} >
            <DialogTitle className={"DialogHeader"}>{"열람권이 필요한 회차"}</DialogTitle>
            <DialogContent className={"DialogBody"}>
                {"해당 회차는 유료 회차로\n 열람권 구매가 필요합니다."}
            </DialogContent>
            <DialogActions className={"DialogActions"}>
                <Button variant={"contained"} fullWidth disableElevation
                    onClick={fn.gotoByAnchor} href={`/payment/${serviceId}/${titleId}`}
                >
                    {"구매 페이지로 이동"}
                </Button>
                <Button fullWidth onClick={() => setIsPayAsking(false)} >
                    {"취소"}
                </Button>
            </DialogActions>
        </Dialog>
    </div>)
}

const EpisodeItem = ({
    serviceId, titleId, thumbnail,
    title, episode,
    setIsPayAsking
}:{
    serviceId: string, titleId: string, thumbnail: string,
    title: TitleType & TitleAugmentedData, episode: EpisodeType,
    setIsPayAsking: (value: boolean) => void
}) => {
    return(<Button className={`EpisodeItem ${
        localStorage.getItem(`contents:${serviceId}:${titleId}:${episode.episodeId}`)?"Read":""
    }`}
        onClick={(e) => {
            e.preventDefault();
            if (episode.isFree || title.timeRemain > 0) {
                fn.gotoByAnchor(e);
                return;
            }
            setIsPayAsking(true);
        }}
        href={`/contents/${serviceId}/${titleId}/${episode.episodeId}`}>
        <img src={thumbnail} alt={"aa"} className={"ItemImage"} />
        <div className={"ItemInformations"}>
            <div className={"EpisodeTitle"} >
                {episode.title}
            </div>
            <div className={"EpisodeTime"} >
                {moment.tz(episode.createdAt * 1000, 'asia/seoul').format("YYYY.MM.DD")}
            </div>
        </div>
        <div className={"ViewWebtoon"} >
            {episode.isFree?"무료":"보기"}
        </div>
    </Button>)
}

export default EpisodeList;